module.exports = {
	"library.navbar.sign_up": "Registrieren",
	"library.navbar.sign_in": "Anmelden",
	"library.navbar.sign_out": "Abmelden",
	"library.navbar.help": "Hilfe",
	"library.navbar.search_for_events": "Events suchen",
	"library.navbar.enter_location": "Standort eingeben",
	"library.navbar.find_events": "Events finden",
	"library.navbar.create_event": "Event erstellen",
	"library.navbar.host_events": "Events veranstalten",
	"library.navbar.dashboard": "Dashboard",
	"library.navbar.my_events": "Meine Events",
	"library.navbar.my_tickets": "Meine Tickets",
	"library.navbar.admin_panel": "Admin panel",
	"library.navbar.profile": "Profil",
	"library.navbar.messages": "Nachrichten",
	"library.navbar.settings": "Einstellungen",
	"library.navbar.search_cities": "Städte suchen",
	"library.navbar.help_center": "Hilfe-Center",
	"library.navbar.cant_find_tickets": "Wo sind meine Tickets?",
	"library.navbar.contact_organizer": "Veranstalter kontaktieren",
	"library.navbar.can_refund": "Kann ich eine Rückerstattung bekommen?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/de.json
// module id = 1510
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16